import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  async function handleResetRequest(e) {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/update-password`,
    });

    if (error) {
      setMessage(error.message);
    } else {
      setMessage('Check your email for the password reset link!');
      setEmail('');
    }
    
    setLoading(false);
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', fontFamily: 'Poppins, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '20px' }}>
        <div style={{ background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#1e293b', marginBottom: '10px', textAlign: 'center' }}>Reset Password</h1>
          <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '30px', textAlign: 'center' }}>Enter your email and we'll send you a reset link</p>

          <form onSubmit={handleResetRequest}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: '12px', marginBottom: '20px', border: '2px solid #e2e8f0', borderRadius: '8px', fontSize: '15px', outline: 'none' }}
            />
            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: '14px', background: loading ? '#94a3b8' : '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', marginBottom: '15px' }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          {message && <div style={{ padding: '12px', background: '#dcfce7', borderRadius: '8px', marginBottom: '15px', fontSize: '14px', color: '#166534', textAlign: 'center' }}>{message}</div>}

          <a href="/" style={{ display: 'block', textAlign: 'center', color: '#3b82f6', textDecoration: 'none', fontSize: '14px', fontWeight: '500' }}>Back to Sign In</a>
        </div>
      </div>
    </div>
  );
}
